/**
 * Whether this tenant's teachers and students see the region an upload drew on
 * a question's pages for the model. Only attempts drawn on have a region to
 * show — the `solution_split_region_hint` gate decides that, per student, at
 * upload. Admin always sees exactly what the model read.
 *
 * The editor of the `solutionRegionDisplay` tenant setting, framed by
 * TenantSettingsTab. See docs/FeatureDesigns/solution-analysis/student-work-pages-target.md §6.
 */
import { useState } from 'react';
import { Button, Select } from '@shared-ui/components';
import type { SettingEditorProps } from './TenantSettingsTab';

export function SolutionRegionDisplayEditor({ value, save, saving, actions }: SettingEditorProps<'solutionRegionDisplay'>) {
    const [teacher, setTeacher] = useState(value.teacher);
    const [student, setStudent] = useState(value.student);
    const dirty = teacher !== value.teacher || student !== value.student;
    const choice = (label: string, on: boolean, set: (v: boolean) => void) => (
        <label>
            {label}{' '}
            <Select aria-label={label} value={on ? 'region' : 'clean'} onChange={e => set(e.target.value === 'region')}>
                <option value="clean">Pages as uploaded</option>
                <option value="region">Pages with the region drawn</option>
            </Select>
        </label>
    );
    return (
        <div className="tenants-form">
            {choice('Teachers see', teacher, setTeacher)}
            {choice('Students see', student, setStudent)}
            <div className="tenant-detail-save">
                {dirty && <span className="tenant-detail-note">Unsaved changes</span>}
                {actions}
                <Button onClick={() => save({ teacher, student })} loading={saving} disabled={!dirty}>Save</Button>
            </div>
        </div>
    );
}
